import React from 'react';
import { AlertTriangle } from 'react-feather';
import { useNavigate } from 'react-router-dom';

const SoS = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/sos');
  };

  return (
    <div className="notification-box position-relative" style={{ cursor: 'pointer', margin: '0 10px' }}>
      <AlertTriangle onClick={handleClick} style={{ color: '#6c757d' }} />
    </div>
  );
};

export default SoS;